import { Box, Modal } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { TokenInnerPopup } from "./TokenInnerPopup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CircularLoader from "../CircularLoader/CircularLoader";
import environmentVariables from "../../config/environmentVariables";
import { init } from "../../config/provider";
import { buyTokenPopUpContext } from "../../context/buyTokenPopUpContext";
import { truncateNumberBalance } from "../../config/common";
import { useSocket } from "../../context/socketContext";
const MldTokenIcon   = `${environmentVariables?.cdnUrl}mldtokenicon.png`
const LordTokenIcon  = `${environmentVariables?.cdnUrl}lordtokenicon.png`
const MaticTokenIcon = `${environmentVariables?.cdnUrl}matictokenicon.png`
const ustdTokenIcon  = `${environmentVariables?.cdnUrl}usdticonupdated.png`

const Root = styled.div``;

const style = {
  position: "absolute",
  top: "49.5%",
  left: "1.5%",
  height: "100vh",
  transform: "translate(-10%, -50%)",
  width: "350px",
  bgcolor: "#1a1c1f",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "0px",
  padding: "30px 21px",
  backgroundColor: "#07121a",
  overflowY: "scroll",
  scrollbarWidth: "none",

  "@media (max-width: 1000px)": {
    left: "3%",
  },
  "@media (max-width: 600px)": {
    left: "10%",
    width: "100vw"
  },
  "&::-webkit-scrollbar": {
    display: "none",
  },

  "@media (max-height: 480px)" : {
    width: "100vw",
    transform: "translate(0, -50%)",
    left: "10%",
  },
};

const ProfileAddresCloseWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0 30px 0;
  
  @media (max-height: 480px) {
    margin: 0px 0 10px 0;
  }

  
`;
const ChainWrapper = styled.div``;
const ChainNameText = styled.text`
  margin-left: 10px;
  font-weight: 400;
  text-align: right;
  color: #969696;
  line-height: 1;
  font-size: 16px;
  font-family: SweraDemo;
`;
const ProfilAddressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ProfileWrapper = styled.div`
  color: white;
  background-color: #212327;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
`;
const Profile = styled.img`
  width: 40px;
  border-radius: 20px;
`;
const AddressTextWrapper = styled.div`
  margin: 0 20px;
`;
const PopUpcloseWrapper = styled.div`
  background-color: gray;
  width: 42px;
  border-radius: 20px;
  height: 40px;
`;

const PopupCloseButton = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  cursor: pointer;
  font-size: 21px;
`;
const AddressText = styled.div`
  font-size: 20px;
  font-weight: 800;
  text-align: LEFT;
  color: #fff;
  line-height: 50px;
`;

const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 0 20px;
`;
const Text = styled.div`
  font-size: 16px;
  font-weight: bold;
  font-family: "SweraDemo";
  padding: 10px 0;
  font-weight: 700;
  color: #fff;
`;
const Tokenstripwrapper = styled.div`
  background-color: #0b1a24;
  border: 1px solid #13232e;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 10px 15px;
  border-radius: 8px;
  margin: 15px 0;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;
const TokenstripwrapperHead = styled.div`
  padding: 15px 10px;
  background: none;
  border-bottom: 1px solid #eeeeee21;
  /* border: 0px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  /* border-radius: 8px; */
  /* margin: 15px 0; */
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;
const TokenContainer = styled.div``;
const ImageTextWrapper = styled.div`
  display: flex;
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 30px;
  height: 30px;
  background-color: none;
  border-radius: 25px;
  padding-left: 5px;
`;
const Image = styled.img`
  width: 35px;
`;
const TokenTextWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0 15px;
  position: relative;
`;
const TokenTextHead = styled.div`
  font-family: "Lato";
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  line-height: 1;
  padding: 10px 20px 10px 10px;
`;
const TokenText = styled.text`
  font-family: "lato";
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
`;
const TokenTextHistory = styled.text`
  font-family: "lato";
  text-align: left;
  font-size: 16px;
  /* font-weight: 700; */
  color: #d5d5d5;
  line-height: 1;
`;
const Tokenpricewrapper = styled.div`
  font-size: 18px;
  font-weight: 400;
  font-family: "SweraDemo";
  display: flex;
  flex-direction: column;
`;
const Tokenprice = styled.div`
  font-family: "lato";
  /* text-align: left; */
  font-size: 18px;
  font-weight: 700;
  color: #cfcfcf;
  /* font-weight: 600; */
  line-height: 1;
`;
const ButtonWrapper = styled.div``;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  margin: 10px 12px;
  cursor: pointer;
  background-color: rgb(146 95 146);
  color: white;
`;

const TransactionSection = styled.div`
  margin-top: 50px;
  font-family: "lato";
`;

const TransactionSmallText = styled.div`
  font-family: "lato";
  color: #9a9fa3;
  font-size: 13px;
  padding-top: 5px;
`;
const TokenTextWrapper1 = styled.div`
  display: block;
  align-items: center;
  text-align: left;
  justify-content: center;
  padding: 0 15px;
  padding-left: 0;
  position: relative;
`;

const TransactionButton = styled.button`
  color: #0a0a0a;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #172b38;
  background-color: #ffffff;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  text-align: center;
  padding: 12px 20px;
  width: fit-content;
  margin-top: 30px;
`;

const TransactionButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const WalletDetailsPopup = ({
  getInformation,
  userBalance,
  getUserBalance,
  allContractDetails,
  setAllContractDetails,
  showNavigation,
  setShowNavigation,
  walletPopUpOpen,
  handleClose,
  checkPerDayLimit,
  isSwapsLoading,
  setIsSwapsLoading,
  userSwapsToday,
  setUserSwapsToday,
  CheckIsUserWhitelisted,
  isUserWhitelisted,
  setIsUserWhitelisted,
}) => {
  const handleOpen = () => setOpen(true);
  const [open, setOpen] = useState(false);
  const handleClosefirst = () => setOpen(false);
  const handleOpen2 = () => setOpen2(true);
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => setOpen2(false);

  const handleOpen3 = () => setOpen3(true);
  const [open3, setOpen3] = useState(false);
  const handleClose3 = () => setOpen3(false);

  const handleOpen4 = () => setOpen4(true);
  const [open4, setOpen4] = useState(false);
  const handleClose4 = () => setOpen4(false);

  const handleOpen5 = () => setOpen4(true);
  const [open5, setOpen5] = useState(false);
  const handleClose5 = () => setOpen5(false);

  const { popUpCurrency, isBuyOpen } = useContext(buyTokenPopUpContext);

  const [mldTokenName, setMldTokenName] = useState("MLD");
  const [maticTokenName, setMaticTokenName] = useState("MATIC");
  const [lordTokenName, setLordTokenName] = useState("LORD");
  const [usdtTokenName, setUsdtTokenName] = useState("USDT (POLYGON)");
  const [balance, setBalance] = useState(userBalance?.MLDBalanceDec);
  const socket = useSocket();
  const [transactionHistory, setTransactionHistory] = useState(null);
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const showBalanceChangeNotification = (newBalance) => {
    // Swal.fire({
    //   icon: "success",
    //   title: "Balance Updated!",
    //   text: `Your balance is:${newBalance}MLD`,
    //   toast: true,
    //   timer: 2000,
    //   position: "bottom-right",
    // });
  };
  useEffect(()=>{
      if(allContractDetails?.address){
        socket.on("register",allContractDetails?.address.toLowerCase())
      socket.on("notifications",(data)=>{
        getUserBalance(allContractDetails?.address)
        getRecentTransactions();
      })
      }
      return ()=>{
        socket.off("notifications")
      }
    },[socket,allContractDetails])
  useEffect(()=>{
    const params=new URLSearchParams(location.search);
    const action=params.get("action");
    if(action=='swap'){
      handleOpen2();
    }

    // console.log(action,token,'//////////////////////////////////////////////////////////////////')
  },[])
// console.log(walletPopUpOpen,'nkajsdnkjadkjadjkasbfkjsa')
  useEffect(()=>{
   
    if(walletPopUpOpen=="MLD"){
      handleOpen()
    }else if(walletPopUpOpen=="MATIC"){
handleOpen3()
    }else if(walletPopUpOpen=="LORD"){
handleOpen2()
    }else if(walletPopUpOpen=="USDT"){
 handleOpen4()
    }
  },[walletPopUpOpen])
   useEffect(()=>{
    const params=new URLSearchParams(location.search);
    // const action=params.get("action");
    const token=params.get("token");
    if(token=="mld"){
      handleOpen()
    }else if(token=="lord"){
      handleOpen2()
    }else if(token=="usdt"){
      handleOpen4()
    }else if(token=="matic"){
      handleOpen3()
    }
    // console.log(action,token,'//////////////////////////////////////////////////////////////////')
  },[])
  const getTransactionAmount = (val, currency) => {
    let num;
    let formattedNum;
    if (currency == "USDT") {
      num = Number(val / 1000000);
    } else {
      num = Number(val / 1000000000000000000);
    }
    const decimalPlaces = (num.toString().split(".")[1] || "").length;
    if (Number.isInteger(Number(num))) {
      formattedNum = num.toString();
    } else if (decimalPlaces > 4) {
      formattedNum = parseFloat(num).toFixed(4);
    } else {
      formattedNum = num.toString();
    }
    return formattedNum;

    // let num;
    // if (currency == "MLD") {
    //   if (Number.isInteger(Number(val))) {
    //     num = parseInt(val / 1000000000000000000);
    //   } else {
    //     num = parseFloat(val / 1000000000000000000).toFixed(4);
    //   }
    //   return num;
    // } else if (currency == "LORD") {
    //   if (Number.isInteger(Number(val))) {
    //     num = parseInt(val / 1000000000000000000);
    //   } else {
    //     num = parseFloat(val / 1000000000000000000).toFixed(4);
    //   }
    //   return num;
    // } else if (currency == "USDT") {
    //   if (Number.isInteger(Number(val))) {
    //     num = parseInt(val / 1000000);
    //   } else {
    //     num = parseFloat(val / 1000000).toFixed(4);
    //   }
    //   return num;
    // } else {
    //   if (Number.isInteger(Number(val))) {
    //     num = parseInt(val / 1000000000000000000);
    //   } else {
    //     num = parseFloat(val / 1000000000000000000).toFixed(4);
    //   }
    //   return num;
    // }
  };
  const isSendOrReceived = (address) => {
   try{
     if (address.toLowerCase() == allContractDetails?.address.toLowerCase()) {
      return "Received";
    } else {
      return "Sent";
    }
   }catch(err){
    console.log(err);
   }
  };

  const getMonthName = (num) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sepr",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[num];
  };
  //unixTimestamp = 1758641625829
  const getConvertedDate = (unixTimestamp) => {
    const date = new Date(Number(unixTimestamp));
    // Get the various components of the date and time
    const year = date.getFullYear();
    const month = getMonthName(date.getMonth()); // Months are zero-indexed, so add 1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds();

    // You can format these components as needed, for example, in a user-friendly string
    const formattedDate = `${month}-${day} , ${hours}:${minutes}`;

    // console.log(formattedDate);
    return formattedDate;
  };
  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails?.address;
      setAddress(address);
    } else {
      setAddress("");
    }
  }, [allContractDetails]);
  const getRecentTransactions = () => {
    // setLoading(true);
    if (allContractDetails) {
      axios
        .get(
          `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_recent_trx?address=${allContractDetails?.address}`
        )
        .then((res) => {
          // console.log(res.data, "asdasdasd");
          // console.log(res?.data?.result, "transactionhistorydetails");
          setTransactionHistory(res?.data?.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getRecentTransactions();
  }, [allContractDetails, userBalance]);


  useEffect(() => {
    if (isBuyOpen) {
      if (popUpCurrency && popUpCurrency.toLowerCase() == "mld") {
        handleOpen();
      } else if (popUpCurrency && popUpCurrency.toLowerCase() == "lord") {
        handleOpen2();
      } else if (popUpCurrency && popUpCurrency.toLowerCase() == "usdt") {
        handleOpen4();
      } else if (popUpCurrency && popUpCurrency.toLowerCase() == "matic") {
        handleOpen3();
      } 
    }
  }, [isBuyOpen]);
  useEffect(() => {
    if (userBalance?.MLDBalanceDec !== undefined) {
      setBalance(userBalance.MLDBalanceDec); // Update the balance when userBalance is available
      showBalanceChangeNotification(userBalance.MLDBalanceDec);
    }
    // setBalance((prevBalance) => userBalance?.MLD);
    // showBalanceChangeNotification(userBalance?.MLD);
  }, [userBalance]);
  const handleLogin = () => {
    try {
      init()
        .then((res) => {
          setAllContractDetails(res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const desiredTokenSymbols = ["MATIC", "MLD", "LORD", "USDT"];
  let filteredTransactions = transactionHistory;
  // if (allContractDetails) {
  //   filteredTransactions = transactionHistory?.filter((transaction) => {
  //     return desiredTokenSymbols?.includes(transaction.tokenSymbol);
  //   });
  // }
  // console.log(transactionHistory, "filteredtrans");
  const TransactionHandler = () => {
    navigate("/trxhistory");
    handleClose();
  };

  const isUserLoggedIn = !!address;

  return (
    <Root>
      <Box sx={style}>
        {/* <div style={{color:"white", cursor:"pointer"}} onClick={handleClosefirst}>Back Button</div> */}
        {/* <button onClick={(e) => {
  e.stopPropagation();
  setShowNavigation(!showNavigation);
  handleClosefirst(); 
  }}> Back </button> */}
        <ProfileAddresCloseWrapper>
          <ProfilAddressWrapper>
            <ProfileWrapper onClick={handleClose}>
              {/* <Profile src={TokenProfile} /> */}
              <i class="fa-solid fa-angle-left"></i>
            </ProfileWrapper>
            <AddressTextWrapper>
              <AddressText>
                {/* {
                  address ? (
                    <>
                      <span>{address.slice(0,6)}...{address.slice(address.length-4, address.length)}</span>
                      <Button styled={{margin:"0 10px"}} onClick={logoutWallet}> Logout </Button>
                    </>
                  ) : <Button onClick={connectWallet}> Connect Wallet </Button>
                } */}

                {/* 0xc342...a9d7 */}
              </AddressText>
            </AddressTextWrapper>
          </ProfilAddressWrapper>
          {/* <PopUpcloseWrapper onClick={()=> alert("asdasdas")}>
        <PopupCloseButton >
        <i class="fa-solid fa-angle-left"></i>
        </PopupCloseButton>
    </PopUpcloseWrapper> */}
        </ProfileAddresCloseWrapper>

        <TextWrapper>
          <Text>META Wallet </Text>
          <ChainWrapper>
            <ChainNameText>polygon</ChainNameText>
          </ChainWrapper>
        </TextWrapper>
        <TokenContainer>
          <Tokenstripwrapper
            onClick={() => {
              if (allContractDetails?.address) {
                handleOpen();
              }
            }}
          >
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={MldTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>{`${mldTokenName=="MLD"||mldTokenName=="LORD"?"$":""}${mldTokenName}`}</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {`${truncateNumberBalance(userBalance?.MLDBalanceDec,2)}`}
              </Tokenprice>
            </Tokenpricewrapper>
          </Tokenstripwrapper>
          <Modal
            open={open}
            onClose={handleClosefirst}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <TokenInnerPopup
              getInformation={getInformation}
              setOpen={setOpen}
              getUserBalance={getUserBalance}
              userBalance={userBalance}
              address={address}
              allContractDetails={allContractDetails}
              mldTokenName={true}
              TokenName={mldTokenName}
              checkPerDayLimit={checkPerDayLimit}
              isSwapsLoading={isSwapsLoading}
              setIsSwapsLoading={setIsSwapsLoading}
              userSwapsToday={userSwapsToday}
              setUserSwapsToday={setUserSwapsToday}
              CheckIsUserWhitelisted={CheckIsUserWhitelisted}
              isUserWhitelisted={isUserWhitelisted}
              setIsUserWhitelisted={setIsUserWhitelisted}
            />
          </Modal>

          <Tokenstripwrapper
            onClick={() => {
              if (allContractDetails?.address) {
                handleOpen3();
              }
            }}
          >
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={MaticTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>{"POL"}</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {`${truncateNumberBalance(userBalance?.MATIC,4)}`}
              </Tokenprice>
            </Tokenpricewrapper>
          </Tokenstripwrapper>

          <Modal
            open={open3}
            onClose={handleClose3}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <TokenInnerPopup
              getInformation={getInformation}
              setOpen={setOpen3}
              userBalance={userBalance}
              getUserBalance={getUserBalance}
              address={address}
              allContractDetails={allContractDetails}
              TokenName={maticTokenName}
              maticTokenName={true}
              checkPerDayLimit={checkPerDayLimit}
              isSwapsLoading={isSwapsLoading}
              setIsSwapsLoading={setIsSwapsLoading}
              userSwapsToday={userSwapsToday}
              setUserSwapsToday={setUserSwapsToday}
              CheckIsUserWhitelisted={CheckIsUserWhitelisted}
              isUserWhitelisted={isUserWhitelisted}
              setIsUserWhitelisted={setIsUserWhitelisted}
            />
          </Modal>

          <Tokenstripwrapper
            onClick={() => {
              if (allContractDetails?.address) {
                handleOpen2();
              }
            }}
          >
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={LordTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>{`${lordTokenName=="MLD"||lordTokenName=="LORD"?"$":""}${lordTokenName}`}</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {`${truncateNumberBalance(userBalance?.LORD,2)}`}
              </Tokenprice>
            </Tokenpricewrapper>
          </Tokenstripwrapper>
          <Modal
            open={open2}
            onClose={handleClose2}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <TokenInnerPopup
              getInformation={getInformation}
              setOpen={setOpen2}
              userBalance={userBalance}
              getUserBalance={getUserBalance}
              address={address}
              allContractDetails={allContractDetails}
              lordTokenName={true}
              TokenName={lordTokenName}
              checkPerDayLimit={checkPerDayLimit}
              isSwapsLoading={isSwapsLoading}
              setIsSwapsLoading={setIsSwapsLoading}
              userSwapsToday={userSwapsToday}
              setUserSwapsToday={setUserSwapsToday}
              CheckIsUserWhitelisted={CheckIsUserWhitelisted}
              isUserWhitelisted={isUserWhitelisted}
              setIsUserWhitelisted={setIsUserWhitelisted}
            />
          </Modal>

          <Tokenstripwrapper
            onClick={() => {
              if (allContractDetails?.address) {
                handleOpen4();
              }
            }}
          >
            <ImageTextWrapper>
              <ImageWrapper>
                <Image src={ustdTokenIcon} />
              </ImageWrapper>
              <TokenTextWrapper>
                <TokenText>{usdtTokenName}</TokenText>
              </TokenTextWrapper>
            </ImageTextWrapper>
            <Tokenpricewrapper>
              <Tokenprice>
                {truncateNumberBalance(userBalance?.USDT , 4)}
              </Tokenprice>
            </Tokenpricewrapper>
          </Tokenstripwrapper>
          <Modal
            open={open4}
            onClose={handleClose4}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <TokenInnerPopup
              getInformation={getInformation}
              setOpen={setOpen4}
              userBalance={userBalance}
              getUserBalance={getUserBalance}
              address={address}
              allContractDetails={allContractDetails}
              usdtTokenName={true}
              TokenName={usdtTokenName}
              checkPerDayLimit={checkPerDayLimit}
              isSwapsLoading={isSwapsLoading}
              setIsSwapsLoading={setIsSwapsLoading}
              userSwapsToday={userSwapsToday}
              setUserSwapsToday={setUserSwapsToday}
              CheckIsUserWhitelisted={CheckIsUserWhitelisted}
              isUserWhitelisted={isUserWhitelisted}
              setIsUserWhitelisted={setIsUserWhitelisted}
            />
          </Modal>
          <TransactionSection>
            <TokenTextHead>Recent Transactions</TokenTextHead>
            {address ? (
              <>
                {loading ? (
                  <div
                    style={{
                      marginTop: "0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    <CircularLoader></CircularLoader>
                  </div>
                ) : (
                  <>
                    {filteredTransactions && filteredTransactions[0]?.to && filteredTransactions[0]?.from&&
                      filteredTransactions?.map((val) => (
                        <TokenstripwrapperHead
                          onClick={() =>{
                            if(val?.hash){
                              window.open(
                              `https://polygonscan.com/tx/${val?.hash}`,
                              "_blank"
                            )
                            }
                          }}
                        >
                          <TokenTextWrapper1>
                            {val?.to&&val?.from&&<TokenTextHistory>
                              {isSendOrReceived(val?.to) === "Received"
                                ? "From  "
                                : "To  "}
                              {isSendOrReceived(val?.to) === "Received"
                                ? `${val?.from.slice(
                                    0,
                                    6
                                  )}....${val?.from.slice(-6)}`
                                : `${val?.to.slice(0, 6)}....${val?.to.slice(
                                    -6
                                  )}`}
                            </TokenTextHistory>}
                            {/* <TokenText>{val?.tokenSymbol}</TokenText> */}
                           {
                            val?.to&&val?.timestamp&& <TransactionSmallText>
                              {`${isSendOrReceived(
                                val?.to
                              )}  on ${getConvertedDate(val?.timestamp)}`}
                            </TransactionSmallText>
                           }
                          </TokenTextWrapper1>

                          {val?.to&&<Tokenpricewrapper>
                            <Tokenprice>
                              {/* {`${getTransactionAmount(
                        val?.value,
                        val?.tokenSymbol
                      ).toFixed(2)} ${val?.tokenSymbol}`} */}
                              {isSendOrReceived(val?.to) === "Received" ? (
                                <span style={{ color: "#008000 " }}>
                                  {`${val?.amount} ${val?.currency}`}
                                </span>
                              ) : (
                                <span style={{ color: "#B11717" }}>
                                  {`${val?.amount} ${val?.currency}`}
                                </span>
                              )}
                            </Tokenprice>
                          </Tokenpricewrapper>}
                        </TokenstripwrapperHead>
                      ))}
                  </>
                )}
                <TransactionButtonWrapper>
                  <TransactionButton
                    onClick={TransactionHandler}
                    disabled={!address}
                  >
                    View All Transactions
                  </TransactionButton>
                </TransactionButtonWrapper>
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "25px",
                  color: "#ad9c9c",
                  textTransform: "capitalize",
                  fontSize: "20px",
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#919191",
                    textTransform: "initial",
                  }}
                >
                  Please login to view transactions.
                </p>
                <div
                  style={{
                    background: "#172930",
                    borderRadius: "50px",
                    fontSize: "15px",
                    cursor: "pointer",
                    fontWeight: "600",
                    border: "1px solid #153339",
                    padding: "12px 30px",
                    color: "#267383",
                    width: "140px",
                    margin: "0 auto",
                    textAlign: "center",
                  }}
                  onClick={handleLogin}
                >
                  Login
                </div>
              </div>
            )}
            {/* <TransactionButtonWrapper> 
          <TransactionButton onClick={TransactionHandler} disabled={!address}>
              View All Transactions
            </TransactionButton>
            </TransactionButtonWrapper> */}
          </TransactionSection>
        </TokenContainer>
      </Box>
    </Root>
  );
};
